<sh-form-multi-select
    [id]="id + '-read'"
    [label]="readLabel"
    [helpText]="helpText"
    [errorMsg]="errorMsg"
    [control]="readControl"
    [options]="permissionOptions$ | async"
    [multiple]="multiple"
    [placeholderMsg]="noneSelectedMsg"
    [multipleSelectedMsg]="multipleSelectedMsg"
    [allSelectedMsg]="allSelectedMsg"
    class="sh-form-multiselect"
    [canBeIndeterminate]="true"
    [indeterminateMsg]="indeterminateMsg"
    [openDirection]="openDirection"
    [sortAlphabetically]="true"
></sh-form-multi-select>

<sh-form-multi-select
    [id]="id + '-write'"
    [label]="writeLabel"
    [errorMsg]="errorMsg"
    [control]="writeControl"
    [options]="permissionOptions$ | async"
    [multiple]="multiple"
    [placeholderMsg]="noneSelectedMsg"
    [multipleSelectedMsg]="multipleSelectedMsg"
    [allSelectedMsg]="allSelectedMsg"
    class="sh-form-multiselect"
    [canBeIndeterminate]="true"
    [indeterminateMsg]="indeterminateMsg"
    [openDirection]="openDirection"
    [sortAlphabetically]="true"
></sh-form-multi-select>

<sh-form-multi-select
    [id]="id + '-export'"
    [label]="exportLabel"
    [errorMsg]="errorMsg"
    [control]="exportControl"
    [options]="permissionOptions$ | async"
    [multiple]="multiple"
    [placeholderMsg]="noneSelectedMsg"
    [multipleSelectedMsg]="multipleSelectedMsg"
    [allSelectedMsg]="allSelectedMsg"
    class="sh-form-multiselect"
    [canBeIndeterminate]="true"
    [indeterminateMsg]="indeterminateMsg"
    [openDirection]="openDirection"
    [sortAlphabetically]="true"
></sh-form-multi-select>
